// extracted by mini-css-extract-plugin
module.exports = {"StaggeredImagesItem":"StaggeredImagesItem_StaggeredImagesItem__1RzJM","image":"StaggeredImagesItem_image__6htKY","video":"StaggeredImagesItem_video__panMM"};